export default __webpack_public_path__ + "static/media/80s_bg_left@2x.5832653f.jpg";